import { withLogin } from 'HOC';
import { DEFAULT_THUOCSI_LONG_TITLE } from 'constants/data';
import dynamic from 'next/dynamic';
import { doWithServerSide } from 'services/SsrService';
import { IS_UI } from 'sysconfig';

// Must use direct import
// When using dynamic import, when redirect from /ingredients to /home, the CSS for Template is removed, causing missing CSS issue.
// Ref: https://github.com/vercel/next.js/issues/17464
import HomeUser from 'components-v2/organisms/pages/home/HomeUser';
import AuthService from 'services/AuthService';
import { PARTNER_NAME_KIOTVIET } from 'components-v2/mocules/NewSignInUpModalV2/ConstantsSignIn';
const HomeGuest = dynamic(() => import('components-v2/organisms/pages/home/HomeGuest'), { ssr: false });

const pageName = 'home';
const pageTitle = 'Trang chủ';
const bannerStatus = 'ON';

export async function getServerSideProps(ctx) {
  return doWithServerSide(
    ctx,
    async () => {
      const { query } = ctx;

      //Verify Partner
      const { identityId, partnerName, signature } = query;
      let verifyPartner = null;

      // KIOTVIET
      if (query.partnerName === PARTNER_NAME_KIOTVIET && query.signature && query.identityId) {
        verifyPartner = await AuthService.verifyPartnerKIOTVIET({
          identityId,
          partnerName,
          signature,
          // deviceId: cookies.device_id,
          isIgnoreDevice: true,
        });
      }

      return {
        props: {
          SEO_CONFIG: {
            title: DEFAULT_THUOCSI_LONG_TITLE,
          },
          insiderUrl: process.env.URL_INSIDER_POPUP,
          projectId: process.env.PROJECT_ID,
          verifyPartner,
        },
      };
    },
    {
      initZustand: ['banners'],
    },
  );
}

function HomePage(props) {
  return IS_UI && !props.isAuthenticated ? (
    <HomeGuest {...props} pageName={pageName} pageTitle={pageTitle} showTopSearchMV2 bannerStatus={bannerStatus} />
  ) : (
    <HomeUser {...props} pageName={pageName} pageTitle={pageTitle} bannerStatus={bannerStatus} />
  );
}

export default withLogin(HomePage, false);

